import { Theme, rem, spacing, token } from '@thiememeulenhoff/lit-sdk';
import { css } from 'lit';
import { tagName } from '../../../helpers';
import { theme as ButtonTheme } from '../../button/button.styles';

export const tag = tagName('list-item');
export const theme = new Theme(tag);

const padding = theme.var('padding', spacing(150));

export const styles = css`
  :where(li) {
    block-size: 100%;
    border-style: solid;
    border-width: 0;
    box-sizing: border-box;
    display: block;
    padding: ${padding};
    ${theme.props([
      ['border-color', 'border-color', token('border-tertiary')],
      ['background-color', 'background-color', token('background-secondary')],
      ['color', 'color', token('foreground-primary')],
      ['border-block-end-width', 'border-block-end-width', rem(1)],
      ['border-inline-end-width', 'border-inline-end-width', rem(0)],
    ])};
  }

  :host(:last-of-type) :where(li),
  :host([no-border]) :where(li) {
    border-block-end: 0 none;
  }

  :host([spacer]) {
    flex: 1;
  }

  ::slotted(a-accordion) {
    inline-size: calc(100% + (${padding} * 2));
    margin: calc(${padding} * -1);
  }

  ::slotted(a-button) {
    display: block;
    margin: calc(${padding} * -1);

    ${ButtonTheme.propertyName('grey-background')}: transparent;
    ${ButtonTheme.propertyName('grey-background-hover')}: ${token(
      'background-quaternary',
    )};
    ${ButtonTheme.propertyName('grey-background-active')}: ${token(
      'background-secondary-pressed',
    )};
    ${ButtonTheme.propertyName('grey-color')}: ${token('foreground-secondary')};
    ${ButtonTheme.propertyName('grey-color-hover')}: ${token(
      'foreground-primary',
    )};
    ${ButtonTheme.propertyName('padding')}: ${padding};
    ${ButtonTheme.propertyName('border-radius')}: 0;
    ${ButtonTheme.propertyName('block-size')}: auto;
    ${ButtonTheme.propertyName('line-height')}: 1.5;
    ${ButtonTheme.propertyName('font-size')}: ${rem(16)};
    ${ButtonTheme.propertyName('font-weight')}: normal;
    ${ButtonTheme.propertyName('box-shadow')}: none;
  }
`;
